module.exports = __webpack_public_path__ + "static/7-habits-d21c5e1eb9037e26be7b7d338b916d24.webp";